import React from 'react'
import PlayerRow from './player-row'

export default function PlayersTable(props) {
  const game = props.game
  const currencyName = game.currency == 'usd' ? '' : ` (${game.currency.toUpperCase()})`

  const rows = () => {
    return props.playerReservations.map(pr => {
      return <PlayerRow
        game={game}
        pr={pr}
        key={pr.id}
        onRenamePlayer={props.onRenamePlayer}
        onEditCost={props.onEditCost}
        onDeletePlayer={props.onDeletePlayer}
        onShowPlayer={props.onShowPlayer}
        onShowReceipt={props.onShowReceipt}
        onRefundPaidFor={props.onRefundPaidFor}
        onRefund={props.onRefund}
        onPayment={props.onPayment}
        onChangeReservation={props.onChangeReservation}
      />
    }) 
  }
  return <table className='table table-striped text-center player-reservations-table'>
    <thead>
      <tr>
        <th>Player Name</th>
        <th>{`Player Cost${currencyName}`}</th>
        <th>Pay</th>
        <th>Delete</th>
      </tr>
    </thead>
    <tbody className='player-wrapper'>
      { 
        rows()
      }
    </tbody>
  </table>
}
